import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/view/index';//首页登录
import Comment from "@/view/comment";//总页面入口
import Overview from "@/view/Overview";//总览
import UserInfo from "@/view/HomePage/userInfo";//用户资料
import Message from "@/view/HomePage/Message";//消息列表
import SupplierCert from "@/view/HomePage/SupplierCert";//供应商列表
import BiddingProject from "@/view/Project/BiddingProject";//项目列表
import BiddingUserProject from "@/view/Project/BiddingUserProject";//用户项目列表
import BiddingProjectDetail from "@/view/Project/BiddingProjectDetail";//项目管理
import ProjectDetailBidding from "@/view/Project/ProjectDetailBidding";//项目沟通
import PublishProject from "@/view/Project/PublishProject";//发布项目
import PublishBiddingProject from "@/view/Project/PublishBiddingProject";//发布竞标信息
import CapitalDetail from "@/view/AccountManage/CapitalDetail";//资金明细
import CashWithDrawal from "@/view/AccountManage/CashWithDrawal";//资金提现
import CashWithApply from "@/view/AccountManage/CashWithApply";//资金提现
import Supplier from "@/view/SupplierList/SupplierList";//供应商认证列表
import SupplierInvite from "@/view/SupplierList/SupplierListInvite";//供应商邀请列表

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path:'/index',
      name:'Comment',
      component: Comment,
      children:[{
        path: '',//总览
        name: 'Overview',
        component: Overview
      },{
        path: 'UserInfo',//个人主页
        name: 'UserInfo',
        component: UserInfo
      },{
        path: 'Message',//消息列表
        name: 'Message',
        component: Message
      },{
        path: 'SupplierCert',//供应商认证（审核）
        name: 'SupplierCert',
        component: SupplierCert
      },{
        path: 'BiddingProject',//竞标项目
        name: 'BiddingProject',
        component: BiddingProject
      },{
        path: 'BiddingUserProject',//竞标项目
        name: 'BiddingUserProject',
        component: BiddingUserProject
      },{
        path: 'BiddingProjectDetail',//竞标项目
        name: 'BiddingProjectDetail',
        component: BiddingProjectDetail
      },{
        path: 'ProjectDetailBidding',//竞标项目
        name: 'ProjectDetailBidding',
        component: ProjectDetailBidding
      },{
        path: 'CapitalDetail',//资金明细
        name: 'CapitalDetail',
        component: CapitalDetail
      },{
        path: 'CashWithDrawal',//提现审批
        name: 'CashWithDrawal',
        component: CashWithDrawal
      },{
        path: 'CashWithApply',//资金提现
        name: 'CashWithApply',
        component: CashWithApply
      },{
        path: 'Supplier',//供应商认证列表（特殊身份登录进来）
        name: 'Supplier',
        component: Supplier
      },{
        path: 'SupplierInvite',//供应商认证列表（特殊身份登录进来）
        name: 'SupplierInvite',
        component: SupplierInvite
      },{
        path: 'PublishProject',//发布项目
        name: 'PublishProject',
        component: PublishProject
      },{
        path: 'PublishBiddingProject',//发布竞标信息
        name: 'PublishBiddingProject',
        component: PublishBiddingProject
      }]

    },
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js